import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import CONF from './../config/config.js';

// externalHref builds the href for an external menu item. Absolute (http…) links are used as-is,
// bare paths get a leading slash. For items flagged authToken, it appends the logged-in Bradman
// access token so the target service (standalone auth) can validate it:
// ?authToken=<accessToken>&origin=BRADMAN. The target strips the token from the URL after first load.
const externalHref = (item) => {
    let href = /^https?:\/\//.test(item.link) ? item.link : '/' + item.link;
    if (item.authToken) {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const token = user && user.accessToken;
            if (token) {
                const sep = href.indexOf('?') === -1 ? '?' : '&';
                href += sep + 'authToken=' + encodeURIComponent(token) + '&origin=BRADMAN';
            }
        } catch (e) {
            /* no/invalid stored user — fall back to the bare link (service will 401) */
        }
    }
    return href;
};

const MenuItem = ({ item, onClickItem, selectedItem }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const dashboardRef = useRef(null);
    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    useEffect(() => {
        if (item.display === 'Turing') {
            setIsCollapsed(false);
        }
    }, []);
    useEffect(() => {
        if (!isCollapsed) {
            dashboardRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }, [isCollapsed]);

    return (
        <React.Fragment>
            <div
                {...(item.isExpandable ? { onClick: toggleCollapse } : {})}
                className="menuItemContainer"
                ref={dashboardRef}
            >
                {item.children && item.children.length > 0 ? (
                    // <span className={item.header ? 'menuHeader' : ''}>
                    //     {item.display}
                    // </span>
                    item.header ? (
                        <span className="menuHeader">{item.display}</span>
                    ) : (
                        item.display
                    )
                ) : item.external ? (
                    // Link to another app (e.g. warehouse-analytics-service), not a React route —
                    // use a plain anchor (new tab) so the browser does a full navigation instead of
                    // client-side routing. Absolute URLs (http…) are used as-is; bare paths get a
                    // leading slash for same-origin links.
                    <a
                        className={
                            selectedItem === item.display
                                ? 'selectedMenuItem'
                                : 'unselectedMenuItem'
                        }
                        href={externalHref(item)}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            onClickItem(item.id);
                        }}
                    >
                        {item.display}
                    </a>
                ) : (
                    <NavLink
                        className={
                            selectedItem === item.display
                                ? 'selectedMenuItem'
                                : 'unselectedMenuItem'
                        }
                        onClick={() => {
                            onClickItem(item.id);
                        }}
                        to={'/' + item.link}
                    >
                        {item.display}
                    </NavLink>
                )}
                {
                    item.isExpandable &&
                        // <span className="dropDownIcon">
                        item.children &&
                        item.children.length > 0 &&
                        (isCollapsed ? (
                            <i className="fas fa-chevron-down pull-right dropDownIcon"></i>
                        ) : (
                            <i className="fas fa-chevron-up pull-right dropDownIcon"></i>
                        ))
                    // </span>
                }
            </div>
            {!isCollapsed && item.children && (
                <div
                    className={item.isExpandable ? 'back-grey' : ''}
                    style={{ paddingLeft: '20px' }}
                >
                    {item.children.map((child) => (
                        <MenuItem
                            key={child.id}
                            item={child}
                            onClickItem={onClickItem}
                            selectedItem={selectedItem}
                        />
                    ))}
                </div>
            )}
        </React.Fragment>
    );
};

const SideMenu = () => {
    const [selectedItem, setSelectedItem] = useState(null);

    return (
        <div className="left-menu-outer">
            <div className="left-menu">
                {CONF.LEFT_MENU.map((item) => (
                    <MenuItem
                        key={item.id}
                        item={item}
                        selectedItem={selectedItem}
                        onClickItem={(e) => setSelectedItem(e)}
                    />
                ))}
            </div>
        </div>
    );
};

export default SideMenu;



// WEBPACK FOOTER //
// ./src/commons/SideMenu.js